
//==================BEGIN DEPENDENCIES========================

import 'jquery';
  
import 'reflect-metadata';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/utility/namespace/namespace';
  
import A11y from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/utility/a11y/index';  
import SelectableDropdown from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/utility/selectableDropdown/index';  
import Parallax from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/utility/parallax/index';  
import NoScroll from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/utility/no-scroll/index';  

//==================BEGIN PLUGINS========================

import Truncate from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/plugins/authors-truncate/index';  

//==================BEGIN COMPONENTS========================


//==================BEGIN WIDGETS========================

import AccessEntitlements from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/widgets/raa/js/access-entitlements';  
import ExportCitation from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/widgets/export-citations/index';  
import SmartLayout from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/wk/aha/node_modules/ui-theme/widgets/smart-layout/js/smart-layout';  

//==================BEGIN GROUPS========================

import './groups/_bootstrap';

import headerMain from './groups/_header';
const main = (UX) => {
    const $selectableDropdown = Array.prototype.slice.call(document.getElementsByClassName('dropdown-selectable')),
        $parallax = Array.prototype.slice.call(document.getElementsByClassName('parallax')),
        $noScroll = Array.prototype.slice.call(document.querySelectorAll('.js--add-noscroll, .js--remove-noscroll')),
        $truncate = Array.prototype.slice.call(document.getElementsByClassName('authors')),
        $accessEntitlements = Array.prototype.slice.call(document.getElementsByClassName('access-widget')),
        $exportCitation = document.getElementById('exportCitation')

try {
        UX.a11y = new A11y().initialize()
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($selectableDropdown.length ) {
            UX.selectableDropdown = $selectableDropdown
                .map(item=>new SelectableDropdown(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($parallax.length ) {
            UX.parallax = $parallax
                .map(item=>new Parallax(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($noScroll.length ) {
            UX.noScroll = new NoScroll().initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($truncate.length ) {
            UX.truncate = new Truncate($truncate).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($accessEntitlements.length ) {
            UX.accessEntitlements = $accessEntitlements
                .map(item=>new AccessEntitlements(item).initialize())
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($exportCitation ) {
            UX.exportCitation = new ExportCitation($exportCitation).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.smartLayout = new SmartLayout().initialize()
    } catch (err) {
        console.error(err);
    }
    
headerMain(UX);

}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    undefined
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

